import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLightbulb, faRunning, faChartLine, faLayerGroup, faCode, faCogs, faUser, faUsers,
  faBook, faGraduationCap, faChalkboardTeacher, faUserShield, faHandshake, faShieldAlt, faComments,
  faWrench, faChartBar, faTools, faHome, faCog, faQuestionCircle,
  faTags, faShoppingCart, faClock, faFileAlt, faHeart, faBell, faStar, faUserFriends, faLock, faLifeRing,
  faCalendarCheck, faCheckCircle, faGlobe, faCloud, faClipboardCheck, faBookMedical, faPenFancy, faStopwatch,
  faUserTie, faCommentDots, faMedal, faImages, faImage, faQuestion, faBookReader, faAssistiveListeningSystems,
  faGamepad, faMicrophoneAlt, faChalkboard, faUserTag, faUsersCog, faChartPie, faAtom, faHourglassHalf, faSchool,
  faForward, faSearch, faRobot, faBookOpen, faNewspaper, faPoll, faStickyNote, faStream, faTasks, faUserCheck,
  faVideo, faVolumeUp, faPenNib, faBrain, faTrophy, faPlayCircle, faUserGraduate, faProjectDiagram, faCertificate,
  faMicroscope, faMusic, faLaptopCode, faPaintBrush, faCubes, faClipboardList, faAward, faPuzzlePiece, faCalendarAlt
} from '@fortawesome/free-solid-svg-icons';



const SAKSHAMBharatSidebarMenu = ({ selectedRole, onSelectPage }) => {
  const [openMenus, setOpenMenus] = useState({});
  const toggleSubMenu = (menu) => setOpenMenus(prev => ({ ...prev, [menu]: !prev[menu] }));

  const MenuItem = ({ icon, label, page }) => (
    <li
      onClick={() => onSelectPage(page, label)}
      className="cursor-pointer p-2 hover:bg-blue-600 text-white flex items-center gap-2"
    >
      <FontAwesomeIcon icon={icon} /> {label}
    </li>
  );

  const SubMenu = ({ label, icon, children }) => (
    <div>
      <div
        onClick={() => toggleSubMenu(label)}
        className="cursor-pointer p-2 hover:bg-blue-400 flex items-center justify-between"
      >
        <span className="flex items-center gap-2"><FontAwesomeIcon icon={icon} /> {label}</span>
        <span>{openMenus[label] ? '▲' : '▼'}</span>
      </div>
      {openMenus[label] && (
        <ul className="ml-4 border-l border-blue-300 pl-2">
          {children}
        </ul>
      )}
    </div>
  );

  const studentMenu = () => (
    <>
      {/* <SubMenu label="Knowledge Resources" icon={faSchool}>
        <MenuItem icon={faBook} label="BookShelf" page="bookshelf" />
        <MenuItem icon={faGlobe} label="BookWorld" page="bookworld" />
        <MenuItem icon={faCloud} label="Cloud Book" page="cloud-book" />
        <MenuItem icon={faStickyNote} label="FlipNotes" page="flipnotes" />
        <MenuItem icon={faVideo} label="VideoBook" page="videobook" />
        <MenuItem icon={faVideo} label="Attend Live Class" page="live-class" />
        <MenuItem icon={faChartBar} label="Results & Marksheets" page="results-marksheets" />
      </SubMenu>

      <SubMenu label="Productivity Tools" icon={faTasks}>
        <MenuItem icon={faLayerGroup} label="Learning Modules" page="learning-modules" />
        <MenuItem icon={faClipboardList} label="TestBook" page="testbook" />
        <MenuItem icon={faLightbulb} label="Tonic Knowledge" page="tonic-knowledge" />
        <MenuItem icon={faPuzzlePiece} label="Crossword" page="crossword" />
        <MenuItem icon={faNewspaper} label="CAFE Bulletin" page="cafe-bulletin" />
        <MenuItem icon={faPuzzlePiece} label="Tonics Quizzes" page="tonics-quizzes" />
        <MenuItem icon={faQuestion} label="5 Whys" page="5whys" />
        <MenuItem icon={faComments} label="POVify" page="povify" />
        <MenuItem icon={faImage} label="VisualBrief" page="visualbrief" />
        <MenuItem icon={faBookMedical} label="Student Diary" page="student-diary" />
        <MenuItem icon={faPenFancy} label="Student Journal" page="student-journal" />
        <MenuItem icon={faStopwatch} label="Focus Timer" page="focus-timer" />
        <MenuItem icon={faNewspaper} label="News & Updates" page="news-updates" />
      </SubMenu>

      <SubMenu label="Events & Community" icon={faUsers}>
        <MenuItem icon={faCalendarCheck} label="Events" page="events" />
        <MenuItem icon={faUserTie} label="Parent Meetings" page="parent-meetings" />
        <MenuItem icon={faCommentDots} label="Mentor's Remarks" page="mentor-remarks" />
        <MenuItem icon={faMedal} label="Applause Hub" page="applause-hub" />
        <MenuItem icon={faNewspaper} label="Chronicles" page="chronicles" />
        <MenuItem icon={faImages} label="Digital Gallery" page="digital-gallery" />
      </SubMenu>

      <SubMenu label="Performance" icon={faChartLine}>
        <MenuItem icon={faChartPie} label="Performance Analytics" page="performance-analytics" />
        <MenuItem icon={faAward} label="Digital Badges" page="digital-badges" />
      </SubMenu> */}
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-6 gap-6 mb-4 mx-4 py-4 px-4 border border-purple-500 rounded-lg bg-gradient-to-r from-purple-50 to-purple-100 shadow-lg">
        <div className="flex flex-col items-center text-center">
          <Link to="/aicounselling-about" className="flex items-center justify-center w-20 h-20 rounded-full bg-green-600 hover:scale-105 transition-transform">
            <FontAwesomeIcon icon={faQuestionCircle} style={{ color: 'yellow', fontSize: '24px' }} />
          </Link>
          <Link to="/aicounselling" className="mt-2 text-sm font-medium text-orange-600 hover:underline">
            AI Counsellor
          </Link>
        </div>
      
        <div className="flex flex-col items-center text-center">
          <Link to="/applause-marksheet-contest" className="flex items-center justify-center w-20 h-20 rounded-full bg-orange-600 hover:scale-105 transition-transform">
            <FontAwesomeIcon icon={faMedal} style={{ color: 'yellow', fontSize: '24px' }} />
          </Link>
          <Link to="/applause-hub-home" className="mt-2 text-sm font-medium text-orange-600 hover:underline">
            Marksheet!
          </Link>
        </div>
      
        <div className="flex flex-col items-center text-center">
          <Link to="/think5whys-db-list" className="flex items-center justify-center w-20 h-20 rounded-full bg-purple-700 hover:scale-105 transition-transform">
            <FontAwesomeIcon icon={faQuestionCircle} style={{ color: 'yellow', fontSize: '24px' }} />
          </Link>
          <Link to="/rcas/add" className="mt-2 text-sm font-medium text-orange-600 hover:underline">
            RootSol: Act Now
          </Link>
        </div>
      
        <div className="flex flex-col items-center text-center">
          {/* /focus-timer-start */}
          <Link to="" className="flex items-center justify-center w-20 h-20 rounded-full bg-green-600 hover:scale-105 transition-transform">
            <FontAwesomeIcon icon={faClockRotateLeft} style={{ color: 'yellow', fontSize: '24px' }} />
          </Link>
          <p className="mt-2 text-sm font-medium text-gray-800">Focus Timer</p>
        </div>
      
        <div className="flex flex-col items-center text-center">
          <Link to="" className="flex items-center justify-center w-20 h-20 rounded-full bg-yellow-300 hover:scale-105 transition-transform">
            <FontAwesomeIcon icon={faTrophy} style={{ color: 'gray', fontSize: '24px' }} />
          </Link>
          <p className="mt-2 text-sm font-medium text-gray-800">Thinkletics</p>
        </div>
      
        <div className="flex flex-col items-center text-center">
            <Link to="" className="flex items-center justify-center w-20 h-20 rounded-full bg-blue-600 hover:scale-105 transition-transform">
              <FontAwesomeIcon icon={faAward} style={{ color: 'gray', fontSize: '24px' }} />
            </Link>
            <p className="mt-2 text-sm font-medium text-gray-800">SpotSnap</p>
        </div>
      </div>
    </>
  );

  const facultyMenu = () => (
    <>
      {/* 👩‍🏫 Faculty Menu */}

      <SubMenu label="Management" icon={faChalkboardTeacher}>
        <MenuItem icon={faChalkboardTeacher} label="Faculty" page="faculty" />
        <MenuItem icon={faCalendarCheck} label="Routine" page="routine" />
        <MenuItem icon={faClipboardCheck} label="Attendance" page="attendance" />
        <MenuItem icon={faVideo} label="Attend Live Class" page="live-class" />
        <MenuItem icon={faFileAlt} label="Results & Marksheets" page="results" />
      </SubMenu>

      <SubMenu label="Learning & Knowledge" icon={faBookOpen}>
        <MenuItem icon={faBookReader} label="Library" page="library" />
        <MenuItem icon={faBookOpen} label="BookWorld" page="bookworld" />
        <MenuItem icon={faCloud} label="Cloud Book" page="cloudbook" />
        <MenuItem icon={faStickyNote} label="FlipNotes" page="flipnotes" />
        <MenuItem icon={faVideo} label="VideoBook" page="videobook" />
        <MenuItem icon={faLayerGroup} label="Learning Modules" page="learning-modules" />
        <MenuItem icon={faClipboardList} label="TestBook" page="testbook" />
        <MenuItem icon={faBrain} label="Tonic Knowledge" page="tonic-knowledge" />
      </SubMenu>

      <SubMenu label="News & Community" icon={faNewspaper}>
        <MenuItem icon={faNewspaper} label="News & Updates" page="news" />
        <MenuItem icon={faCalendarCheck} label="Events" page="events" />
        <MenuItem icon={faUsers} label="Parent Meetings" page="parent-meetings" />
        <MenuItem icon={faCommentDots} label="Mentor's Remarks" page="mentors-remarks" />
        <MenuItem icon={faStar} label="Applause Hub" page="applause-hub" />
        <MenuItem icon={faStream} label="Chronicles" page="chronicles" />
        <MenuItem icon={faImages} label="Digital Gallery" page="gallery" />
      </SubMenu>

      <SubMenu label="Critical Thinking" icon={faBrain}>
        <MenuItem icon={faQuestionCircle} label="5 Whys" page="5whys" />
        <MenuItem icon={faPoll} label="POVify" page="povify" />
        <MenuItem icon={faProjectDiagram} label="VisualBrief" page="visualbrief" />
      </SubMenu>

      <SubMenu label="DeepTeach Suite" icon={faGraduationCap}>
        <MenuItem icon={faBookOpen} label="Immersive Reading" page="immersive-reading" />
        <MenuItem icon={faAssistiveListeningSystems} label="Dictation & Listening" page="dictation" />
        <MenuItem icon={faUserTag} label="Role-based Learning" page="role-learning" />
        <MenuItem icon={faGamepad} label="Gamified Lessons" page="gamified-lessons" />
        <MenuItem icon={faMicrophoneAlt} label="Speech Coach" page="speech-coach" />
        <MenuItem icon={faChartLine} label="Study Pattern Analysis" page="study-pattern" />
        <MenuItem icon={faClock} label="Exam Scheduler" page="exam-scheduler" />
        <MenuItem icon={faChartPie} label="Competency Mapping" page="competency" />
        <MenuItem icon={faClipboardList} label="Assignments & Feedback" page="assignments" />
        <MenuItem icon={faTrophy} label="Leaderboards" page="leaderboards" />
        <MenuItem icon={faComments} label="Student Forums" page="forums" />
        <MenuItem icon={faChalkboard} label="Virtual Classrooms" page="virtual-classroom" />
        <MenuItem icon={faUserFriends} label="Peer Tutoring" page="peer-tutoring" />
        <MenuItem icon={faLightbulb} label="Brainstorming Hub" page="brainstorming" />
      </SubMenu>

      <SubMenu label="Analytics & Tracking" icon={faChartBar}>
        <MenuItem icon={faUserCheck} label="Attendance Tracker" page="attendance-tracker" />
        <MenuItem icon={faChartBar} label="Performance Analytics" page="analytics" />
        <MenuItem icon={faCertificate} label="Digital Badges" page="badges" />
        <MenuItem icon={faLock} label="Secure Cloud Notes" page="cloud-notes" />
      </SubMenu>

      <SubMenu label="Creative Tools & Innovation" icon={faLaptopCode}>
        <MenuItem icon={faRobot} label="AI Art & Writing Lab" page="ai-lab" />
        <MenuItem icon={faMusic} label="Music-based Learning" page="music-learning" />
        <MenuItem icon={faMicroscope} label="STEM Simulations" page="stem" />
        <MenuItem icon={faCubes} label="Build Learning Games" page="learning-games" />
      </SubMenu>

      <SubMenu label="Author Desk" icon={faPenNib}>
        <MenuItem icon={faUserGraduate} label="My Book Masters" page="book-masters" />
        <MenuItem icon={faBookMedical} label="My DictaBook Sets" page="dictabook" />
        <MenuItem icon={faPenNib} label="Publish Books" page="publish-books" />
        <MenuItem icon={faTasks} label="Authoring Practice Sets" page="practice-sets" />
        <MenuItem icon={faAward} label="Certification Exam Sets" page="certification-sets" />
        <MenuItem icon={faClipboardList} label="Authoring Assignments" page="author-assignments" />
      </SubMenu>

      <SubMenu label="Engagement & Workshops" icon={faUsers}>
        <MenuItem icon={faUsers} label="Readers" page="readers" />
        <MenuItem icon={faFileAlt} label="Results" page="faculty-results" />
        <MenuItem icon={faCertificate} label="Certificates" page="certificates" />
        <MenuItem icon={faChalkboardTeacher} label="My Workshops" page="workshops" />
      </SubMenu>

      <SubMenu label="Fun & Quiz Lounge" icon={faPuzzlePiece}>
        <MenuItem icon={faStream} label="CAFE Bulletin" page="cafe-bulletin" />
        <MenuItem icon={faPuzzlePiece} label="Tonics & Quizzes" page="tonics-quizzes" />
      </SubMenu>
    </>
  );

  const parentMenu = () => (
    <>
      {/* 🧑‍💼 Parent Menu */}

      <SubMenu label="Dashboard & Planning" icon={faHome}>
        <MenuItem icon={faChartPie} label="My Children Activity Dashboard" page="performance-dashboard" />
        <MenuItem icon={faCalendarCheck} label="Planner" page="planner" />
        <MenuItem icon={faClock} label="Schedule Tracker" page="schedule-tracker" />
        <MenuItem icon={faTasks} label="Task Management" page="tasks" />
        <MenuItem icon={faChalkboardTeacher} label="Faculty Overview" page="faculty-overview" />
        <MenuItem icon={faClipboardList} label="Assessment Plans" page="assessment-plans" />
        <MenuItem icon={faBookMedical} label="Academic Health" page="academic-health" />
      </SubMenu>

      <SubMenu label="Parent Connects" icon={faUsers}>
        <MenuItem icon={faUsers} label="Parent Connect" page="parent-connect" />
        <MenuItem icon={faCommentDots} label="Feedback Desk" page="feedback-desk" />
        <MenuItem icon={faBell} label="Alerts" page="alerts" />
        <MenuItem icon={faNewspaper} label="News & Notices" page="news-notices" />
        <MenuItem icon={faVolumeUp} label="Broadcasts" page="broadcasts" />
        <MenuItem icon={faUserShield} label="Policy Center" page="policy-center" />
      </SubMenu>

      <SubMenu label="Account" icon={faChartLine}>
        <MenuItem icon={faTags} label="Fee Structure" page="fee-structure" />
        <MenuItem icon={faShoppingCart} label="Transactions" page="transactions" />
      </SubMenu>

      <SubMenu label="Innovation & Insights" icon={faLightbulb}>
        <MenuItem icon={faBrain} label="Think5Whys" page="think5whys" />
        <MenuItem icon={faPoll} label="POVify" page="povify" />
        <MenuItem icon={faProjectDiagram} label="VisualBrief" page="visualbrief" />
        <MenuItem icon={faRobot} label="AI Insights" page="ai-insights" />
      </SubMenu>

      <SubMenu label="Recognition & Rewards" icon={faAward}>
        <MenuItem icon={faStar} label="Star Performers" page="star-performers" />
        <MenuItem icon={faTrophy} label="Awards & Trophies" page="awards" />
        <MenuItem icon={faCertificate} label="Digital Certifications" page="digital-certifications" />
      </SubMenu>

    </>
  );

  const managementMenu = () => (
    <>
      {/* 🧑‍💼 Management Menu */}

      <SubMenu label="Dashboard & Planning" icon={faHome}>
        <MenuItem icon={faChartPie} label="Performance Dashboard" page="performance-dashboard" />
        <MenuItem icon={faCalendarCheck} label="Planner" page="planner" />
        <MenuItem icon={faClock} label="Schedule Tracker" page="schedule-tracker" />
        <MenuItem icon={faTasks} label="Task Management" page="tasks" />
      </SubMenu>

      <SubMenu label="Academic Oversight" icon={faGraduationCap}>
        <MenuItem icon={faChalkboardTeacher} label="Faculty Overview" page="faculty-overview" />
        <MenuItem icon={faUserGraduate} label="Student Overview" page="student-overview" />
        <MenuItem icon={faBookOpen} label="Curriculum Tracker" page="curriculum-tracker" />
        <MenuItem icon={faClipboardList} label="Assessment Plans" page="assessment-plans" />
        <MenuItem icon={faBookMedical} label="Academic Health" page="academic-health" />
      </SubMenu>

      <SubMenu label="Communication & Engagement" icon={faUsers}>
        <MenuItem icon={faUsers} label="Parent Connect" page="parent-connect" />
        <MenuItem icon={faCommentDots} label="Feedback Desk" page="feedback-desk" />
        <MenuItem icon={faComments} label="Announcements" page="announcements" />
        <MenuItem icon={faStream} label="Community Stories" page="community-stories" />
      </SubMenu>

      <SubMenu label="Resource Management" icon={faCogs}>
        <MenuItem icon={faTools} label="Infrastructure" page="infrastructure" />
        <MenuItem icon={faClipboardCheck} label="Inventory Tracker" page="inventory-tracker" />
        <MenuItem icon={faFileAlt} label="Reports & Logs" page="reports-logs" />
        <MenuItem icon={faCog} label="System Settings" page="system-settings" />
      </SubMenu>

      <SubMenu label="People & Roles" icon={faUserShield}>
        <MenuItem icon={faUsersCog} label="User Roles" page="user-roles" />
        <MenuItem icon={faUserTie} label="Staff Management" page="staff-management" />
        <MenuItem icon={faUserFriends} label="Team Directory" page="team-directory" />
        <MenuItem icon={faHandshake} label="Partnerships" page="partnerships" />
      </SubMenu>

      <SubMenu label="Finance & Commerce" icon={faChartLine}>
        <MenuItem icon={faTags} label="Fee Structure" page="fee-structure" />
        <MenuItem icon={faShoppingCart} label="Transactions" page="transactions" />
        <MenuItem icon={faChartBar} label="Financial Analytics" page="financial-analytics" />
        <MenuItem icon={faMedal} label="Scholarship Tracker" page="scholarship-tracker" />
      </SubMenu>

      <SubMenu label="Security & Compliance" icon={faShieldAlt}>
        <MenuItem icon={faLock} label="Access Control" page="access-control" />
        <MenuItem icon={faUserCheck} label="Audit Logs" page="audit-logs" />
        <MenuItem icon={faLifeRing} label="Support & Helpdesk" page="support-desk" />
        <MenuItem icon={faUserShield} label="Policy Center" page="policy-center" />
      </SubMenu>

      <SubMenu label="Innovation & Insights" icon={faLightbulb}>
        <MenuItem icon={faBrain} label="Think5Whys" page="think5whys" />
        <MenuItem icon={faPoll} label="POVify" page="povify" />
        <MenuItem icon={faProjectDiagram} label="VisualBrief" page="visualbrief" />
        <MenuItem icon={faRobot} label="AI Insights" page="ai-insights" />
        <MenuItem icon={faSearch} label="Trend Finder" page="trend-finder" />
      </SubMenu>

      <SubMenu label="Recognition & Rewards" icon={faAward}>
        <MenuItem icon={faStar} label="Star Performers" page="star-performers" />
        <MenuItem icon={faTrophy} label="Awards & Trophies" page="awards" />
        <MenuItem icon={faCertificate} label="Digital Certifications" page="digital-certifications" />
      </SubMenu>

      <SubMenu label="Broadcast & Alert Center" icon={faBell}>
        <MenuItem icon={faBell} label="Alerts" page="alerts" />
        <MenuItem icon={faNewspaper} label="News & Notices" page="news-notices" />
        <MenuItem icon={faVolumeUp} label="Broadcasts" page="broadcasts" />
      </SubMenu>

    </>
  );

  const partnerMenu = () => (
    <>
      {/* 🤝 Partner Menu */}

      <SubMenu label="Collaborations" icon={faHandshake}>
        <MenuItem icon={faUsers} label="Partner Directory" page="partner-directory" />
        <MenuItem icon={faUserTie} label="Manage Accounts" page="manage-accounts" />
        <MenuItem icon={faProjectDiagram} label="Joint Programs" page="joint-programs" />
      </SubMenu>

      <SubMenu label="Knowledge Sharing" icon={faBookOpen}>
        <MenuItem icon={faBook} label="Library Access" page="partner-library" />
        <MenuItem icon={faBrain} label="Tonic Knowledge" page="tonic-knowledge" />
        <MenuItem icon={faBookReader} label="BookWorld" page="bookworld" />
      </SubMenu>

      <SubMenu label="Insights & Analytics" icon={faChartBar}>
        <MenuItem icon={faChartPie} label="Engagement Reports" page="engagement-reports" />
        <MenuItem icon={faChartLine} label="Performance Analytics" page="performance-analytics" />
        <MenuItem icon={faPoll} label="POVify" page="povify" />
      </SubMenu>

      <SubMenu label="Events & Engagement" icon={faUsers}>
        <MenuItem icon={faCalendarCheck} label="Events" page="events" />
        <MenuItem icon={faImages} label="Digital Gallery" page="digital-gallery" />
        <MenuItem icon={faStream} label="Chronicles" page="chronicles" />
      </SubMenu>

      <SubMenu label="Content & Authoring" icon={faPenNib}>
        <MenuItem icon={faBookMedical} label="Publish Books" page="publish-books" />
      </SubMenu>

      <SubMenu label="Updates & Communication" icon={faBell}>
        <MenuItem icon={faNewspaper} label="News & Updates" page="news-updates" />
        <MenuItem icon={faComments} label="Announcements" page="partner-announcements" />
        <MenuItem icon={faHandshake} label="Partner Messages" page="partner-messages" />
      </SubMenu>
    </>
  );

  const adminMenu = () => (
    <>
      {/* 🛠️ Admin Menu */}

      <SubMenu label="Academic Management" icon={faGraduationCap}>
        <MenuItem icon={faUser} label="Faculty" page="admin-faculty" />
        <MenuItem icon={faUserGraduate} label="Admission" page="admin-admission" />
        <MenuItem icon={faCalendarCheck} label="Routine" page="admin-routine" />
        <MenuItem icon={faUserCheck} label="Attendance" page="admin-attendance" />
        <MenuItem icon={faVideo} label="Attend Live Class" page="admin-live-class" />
        <MenuItem icon={faFileAlt} label="Results & Marksheets" page="admin-results" />
      </SubMenu>

      <SubMenu label="Resources & Knowledge" icon={faBook}>
        <MenuItem icon={faBookOpen} label="Library" page="admin-library" />
        <MenuItem icon={faCloud} label="Cloud Book" page="admin-cloudbook" />
        <MenuItem icon={faStickyNote} label="FlipNotes" page="admin-flipnotes" />
        <MenuItem icon={faVideo} label="VideoBook" page="admin-videobook" />
        <MenuItem icon={faTasks} label="Learning Modules" page="admin-learningmodules" />
        <MenuItem icon={faClipboardList} label="TestBook" page="admin-testbook" />
        <MenuItem icon={faBrain} label="Tonic Knowledge" page="admin-tonic" />
      </SubMenu>

      <SubMenu label="Events & Engagement" icon={faUsers}>
        <MenuItem icon={faCalendarCheck} label="Events" page="admin-events" />
        <MenuItem icon={faImages} label="Digital Gallery" page="admin-gallery" />
        <MenuItem icon={faStream} label="Chronicles" page="admin-chronicles" />
      </SubMenu>

      <SubMenu label="Critical Thinking" icon={faBrain}>
        <MenuItem icon={faQuestion} label="5 Whys" page="admin-5whys" />
        <MenuItem icon={faComments} label="POVify" page="admin-povify" />
        <MenuItem icon={faImage} label="VisualBrief" page="admin-visualbrief" />
      </SubMenu>

      <SubMenu label="DeepTeach Suite" icon={faLightbulb}>
        <MenuItem icon={faCalendarCheck} label="Exam Scheduler" page="admin-examscheduler" />
        <MenuItem icon={faProjectDiagram} label="Competency Mapping" page="admin-competencymapping" />
        <MenuItem icon={faFileAlt} label="Certification Exam Sets" page="admin-certification" />
      </SubMenu>

      <SubMenu label="Author Desk" icon={faPenNib}>
        <MenuItem icon={faBookMedical} label="Publish Books" page="admin-publishbooks" />
        <MenuItem icon={faAward} label="Certificates" page="admin-certificates" />
      </SubMenu>

      <SubMenu label="Performance & Insights" icon={faChartBar}>
        <MenuItem icon={faUserCheck} label="Attendance Tracker" page="admin-attendancetracker" />
        <MenuItem icon={faChartLine} label="Performance Analytics" page="admin-performance" />
        <MenuItem icon={faMedal} label="Digital Badges" page="admin-badges" />
      </SubMenu>

      <SubMenu label="Security & Setup" icon={faCog}>
        <MenuItem icon={faClipboardList} label="My Setup" page="admin-setup" />
        <MenuItem icon={faShieldAlt} label="Secure Notes" page="admin-securenotes" />
      </SubMenu>

      <SubMenu label="Communication" icon={faBell}>
        <MenuItem icon={faNewspaper} label="News & Updates" page="admin-news" />
        <MenuItem icon={faComments} label="Announcements" page="admin-announcements" />
      </SubMenu>

    </>
  );

  const renderByRole = () => {
    switch (selectedRole?.toLowerCase()) {
      case 'student': return studentMenu();
      case 'faculty': return facultyMenu();
      case 'parent': return parentMenu();
      case 'management': return managementMenu();
      case 'partner': return partnerMenu();
      case 'admin': return adminMenu();
      default: return <div className="text-white p-2">No menu available</div>;
    }
  };

  return (
    <div className="flex flex-col w-full sm:w-2/5 md:w-1/4 lg:w-1/5 bg-green-700 text-white border-2 border-green-700 shadow-md h-screen overflow-y-hidden">
      <ul className="p-2 overflow-y-auto max-h-[calc(100vh-64px)]">
        <MenuItem icon={faHome} label="Dashboard" page="dashboard" />
        {renderByRole()}
      </ul>
    </div>
  );
};

export default SAKSHAMBharatSidebarMenu;
